import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import BurgerMenu from './BurgerMenu'

export const Header=()=>{
    
    const navigate=useNavigate()
    const [ariaExpanded,setAriaExpanded]=useState(false)
    return(
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
            <div className="container-fluid">
            <div className="d-flex align-items-center my-1">
                    <div className="mx-2" style={{position:"relative",left:"0px",overflow:"hidden",width:`32px`,height:`40px`}}>
                        <img style={{position:"absolute",left:"0px",height:"100%",width:"100%",objectFit:"fill"}}  src={require("../../static/NR.png")} width="300"/>
                    </div>
                    <div className="mx-2" style={{position:"relative",left:"0px",overflow:"hidden",width:`92px`,height:`20px`}}>
                        <img style={{position:"absolute",left:"0px",height:"100%",width:"100%",objectFit:"fill"}}  src={require("../../static/лого-Апетитна.png")} width="300"/>
                    </div>
                    <div className="mx-2" style={{position:"relative",left:"0px",overflow:"hidden",width:`36px`,height:`41px`}}>
                        <img style={{position:"absolute",left:"0px",height:"100%",width:"100%",objectFit:"fill"}}  src={require("../../static/лого-курка-по-домашньому.png")} width="300"/>
                    </div>
                    <div className="mx-2" style={{position:"relative",left:"0px",overflow:"hidden",width:`36px`,height:`42px`}}>
                        <img style={{position:"absolute",left:"0px",height:"100%",width:"100%",objectFit:"fill"}}  src={require("../../static/лого-Skott-Smeat.png")} width="300"/>
                    </div>
                    <p className='navbar_header_text'>
                        у акції приймають участь продукти цих брендів
                    </p>
                </div>
                <BurgerMenu/>
                <div className="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
                    <div className="navbar-nav ">
                        <p onClick={()=>navigate('/')} className='link_header_text hover-effect'>Головна</p>  
                        <p onClick={()=>navigate('/rules')} className='link_header_text hover-effect'>Правила</p>
                    </div>
                </div>
            </div>
        </nav>
    )
}